const CONSENT_KEY = "mf_cookie_consent";
const CONSENT_VERSION = 1;

// GA4 y Google Ads se cargan de forma centralizada desde Google Tag Manager
// (GTM-NDF9PHQH, snippet oficial en public/index.html). Este módulo NO carga
// ningún script de Google: solo gestiona el consentimiento y envía eventos
// al dataLayer para que GTM los procese.
export const isProductionAnalyticsHost = () =>
  typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  ["midefinca.es", "www.midefinca.es"].includes(window.location.hostname);

// El banner de cookies y la medición solo existen en el dominio de producción.
// En preview (noindex), localhost o cualquier otro host no hay analítica.
export const analyticsConfigured = isProductionAnalyticsHost();

export const getConsent = () => {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed === "accepted") return { analytics: true, version: 0 };
    if (parsed === "rejected") return { analytics: false, version: 0 };
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

const updateGoogleConsent = (analyticsAllowed) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  // El banner actual cubre medición analítica; la publicidad queda denegada.
  window.gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: analyticsAllowed ? "granted" : "denied",
  });
};

export const setConsent = (analyticsAllowed) => {
  localStorage.setItem(
    CONSENT_KEY,
    JSON.stringify({
      analytics: Boolean(analyticsAllowed),
      version: CONSENT_VERSION,
      at: new Date().toISOString(),
    })
  );
  updateGoogleConsent(Boolean(analyticsAllowed));
  // Registrar la página de aterrizaje si el usuario acepta en la primera visita.
  if (analyticsAllowed) trackPageView();
};

// Compatibilidad con CookieConsent (montaje): reaplica el estado de
// consentimiento guardado. GTM se carga desde el <head>; aquí no hay loader.
export const initAnalytics = () => {
  if (!analyticsConfigured) return false;
  const consent = getConsent();
  if (consent) updateGoogleConsent(Boolean(consent.analytics));
  return Boolean(consent?.analytics);
};

export const trackEvent = (name, params = {}) => {
  if (!analyticsConfigured || getConsent()?.analytics !== true) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
};

// Evento SPA de cambio de página. Se llama "mf_page_view" (no "page_view")
// para que en GTM se mapee a un único page_view de GA4 sin duplicados.
export const trackPageView = () => {
  if (!analyticsConfigured || getConsent()?.analytics !== true) return;
  const pagePath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "mf_page_view",
    page_title: document.title,
    page_path: pagePath,
    page_location: `${window.location.origin}${pagePath}`,
  });
};
